(function () {
    window.app = window.app || {};

    if (!window.app.GlobalSettings) {
        window.app.GlobalSettings = $('[id$="siteData"]').data('settings');
    }
})();

$(document).ready(function () {
    $("#faqs .panel-default").click(function () {
        $(this).find(".panel-collapse.collapse").toggle()
        $(this).find(".rotate").toggleClass("down");
    });
});
